import React from "react";
import Sketch from "react-p5";
import p5Types from "p5";

import { drawRect } from "../util";
import AsteroidAgent from "./AsteroidAgent";

import "./game.css";

interface CatchAsteroidProps {
  agents: AsteroidAgent[];
  onExtinct?: () => void;
  playerSpeed: number;
  asteroidSpeed: number;
}

const CatchAsteroid = ({
  agents,
  onExtinct,
  playerSpeed,
  asteroidSpeed,
}: CatchAsteroidProps) => {
  const asteroidRect = {
    x: 420 * Math.random(),
    y: -30,
    width: 30,
    height: 30,
  };
  let score = 0;

  const setup = (p5: p5Types, canvasParentRef: Element) => {
    p5.createCanvas(450, 450).parent(canvasParentRef);
  };

  const draw = (p5: p5Types) => {
    p5.background(230);

    let alive = 0;

    for (const agent of agents) {
      if (!agent.isAlive) continue;
      alive++;

      drawRect(agent.rect, p5.color("rgba(255, 0, 0, 0.3)"), p5);

      switch (agent.update(asteroidRect, p5)) {
        case "left":
          agent.rect.x -= playerSpeed;
          break;
        case "right":
          agent.rect.x += playerSpeed;
          break;
      }
    }

    p5.fill("black");
    p5.textSize(20);
    p5.text("Alive : " + alive, 10, 30);

    if (agents.length > 0 && alive === 0) {
      console.log("extinct");
      if (onExtinct) onExtinct();
      asteroidRect.y = -asteroidRect.height;
      score = 0;
    }

    drawRect(asteroidRect, p5.color("black"), p5);
    asteroidRect.y += asteroidSpeed;
    if (asteroidRect.y + asteroidRect.height >= 400) {
      for (const agent of agents) {
        if (!agent.isAlive) continue;
        if (
          !(
            agent.rect.x - asteroidRect.width < asteroidRect.x &&
            asteroidRect.x < agent.rect.x + agent.rect.width
          )
        ) {
          agent.isAlive = false;
          agent.onDie(score);
        }
      }

      asteroidRect.y = -asteroidRect.height;
      asteroidRect.x = 420 * Math.random();
      score++;
    }
  };

  return <Sketch setup={setup} draw={draw} />;
};

export default CatchAsteroid;
